import { render } from "./locations-list.vue?vue&type=template&id=9ee74936"
import script from "./locations-list.vue?vue&type=script&lang=js"
export * from "./locations-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__